import { transformLocationApiResult } from "../../map/location"
import { IMapContainer, MapLocationsApiResult } from "../../map/types"

interface Props {
    map: IMapContainer,
    close: () => void
}

export const MapViewLocation: React.FunctionComponent<Props> = ({ map, close }) => {

    const [state, setState] = React.useState({
        query: "",
        results: [] as MapLocationsApiResult[],
    })

    const { query, results } = state

    const search = (query: string) => {

        setState({ ...state, query })

        map.queryLocationApi(query).then(r => {
            setState({ ...state, query, results: r || [] })
        })

    }

    const selectLocation = (loc: MapLocationsApiResult, done: boolean) => {
        if (loc) {
            const extent = transformLocationApiResult(loc)
            map.viewExtent(extent)
            if (done) {
                close()
            }
        }
    }

    return <>

        <div className="form-group">
            <i className="icon icon-search"></i>
            <input
                type="text"
                className="form-control input-sm"
                value={query}
                onChange={e => search(e.target.value)}
                placeholder="Type the name of a place or postcode" />
        </div>

        {
            (results.length > 0) &&
            <div className="results">
                <ul>
                    {
                        results.map(l =>
                            <li key={l.name} onClick={() => selectLocation(l, true)} onMouseOver={() => selectLocation(l, false)}>
                                {l.name}
                            </li>
                        )
                    }
                </ul>
            </div>
        }

    </>

}

